import { createContext } from "react";

export const BillOfMaterialContext = createContext({
  billOfMaterial: {},
  onChange: () => {},
});
